import { useLocation } from 'react-router-dom'
import type { ExcelImportResponse } from '../../../model/kartera-api-model'
import { POLICY_IMPORT_EXCEL_PATH, POLICY_IMPORT_PATH } from '../common/policy-import-common'
import type { ExcelResultLocationState } from '../common/policy-import-common'

export interface ExcelResultRow {
    key: string
    ok: boolean
    message: string
    noPoliza: string
    claveAgente: string
    ramo: string
    contratante: string
}

const toRow = (item: ExcelImportResponse, index: number): ExcelResultRow => {
    const poliza = item.poliza
    return {
        key: `${poliza?.rowId?.value || index}-${poliza?.noPoliza?.value || ''}`,
        ok: Boolean(item.ok),
        message: item.message || (item.ok ? 'Póliza importada' : 'No se pudo importar la póliza'),
        noPoliza: poliza?.noPoliza?.value || '—',
        claveAgente: poliza?.claveAgente?.value || '—',
        ramo: poliza?.ramo?.value || '',
        contratante: [poliza?.nombres?.value, poliza?.apPaterno?.value, poliza?.apMaterno?.value].filter(Boolean).join(' '),
    }
}

export const usePolicyImportExcelResultModel = () => {
    const location = useLocation()
    const results = (location.state as ExcelResultLocationState | null)?.polizas || []
    const rows = results.map(toRow)
    const imported = rows.filter((row) => row.ok).length

    return {
        rows,
        hasResults: rows.length > 0,
        imported,
        failed: rows.length - imported,
        backTo: POLICY_IMPORT_PATH,
        excelPath: POLICY_IMPORT_EXCEL_PATH,
        policiesPath: '/polizas',
    }
}
